import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import UploadSection from 'Components/UI/UploadSection';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PropTypes from 'prop-types';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';


const useStyles = makeStyles(theme => ({
  root: {
    ...wizardClasses.root(theme),
    margin: 0,
  },
  container: {
    ...wizardClasses.container(theme),
    flexGrow: 1,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3.5),
  },
  upload: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  navigation: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    flexDirection: 'column',
    paddingBottom: theme.spacing(4),
  },
}));

const ApexFundingAccountVerificationActivationTemplate = ({ className }) => {
  const {
    pageContentResource: resource,
    setPageContentCollection,
  } = usePageContentContext();

  const { logStandardizedEvent } = useEventTrackingLogEvent();


  const classes = useStyles();

  async function loadNextStep() {
    const collection = await resource.submit();
    setPageContentCollection(collection);
  }

  const handleOnUploadStart = () => {
    logStandardizedEvent(categories.accountFunding, eventTypes.clickButton, 'upload document for identity verification failure clicked');
  };

  return (
    <Box className={classNames(classes.root, className)}>
      <Box className={classes.container}>
        <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} />
        <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
        <ResourceSummaryCard resource={resource.attr('account').resources().head()} />

        <div className={classes.upload}>
          <UploadSection
            content="Upload Document"
            documentResources={resource.attr('attachedDocuments').resources().list()}
            url={resource.relationship(fr.relationships.uploadDocument.name).link('related').url()}
            onSuccess={loadNextStep}
            buttonTest="identity-verification-upload-button"
            chipTest="identity-verification-upload-chip"
            accept="image/*,.pdf"
            onStart={handleOnUploadStart}
          />
        </div>
      </Box>
    </Box>
  );
};
ApexFundingAccountVerificationActivationTemplate.defaultProps = {
  className: '',
};
ApexFundingAccountVerificationActivationTemplate.propTypes = {
  className: PropTypes.string,
};

export default ApexFundingAccountVerificationActivationTemplate;
